export const UnderConstruction = () => {
    return (
        <div className='container hurme-3-regular letter-spacing'>
            <h1>Nayax Capital</h1>
            <h2>Coming Soon</h2>
        </div>
    )
}